import React, {useState} from 'react';

import {AttachmentFullscreen} from 'src/components/trigger-attachment/attachment-fullscreen';
import {
    AttachmentPreview,
} from 'src/modules/event-review/header-block/event-trigger-attachment/attachment-preview/attachment-preview';
import {EventDetailInfo} from 'src/openapi/models/EventDetailInfo';
import {TriggerAttachment} from 'src/openapi/models/TriggerAttachment';

import Carousel, {CarouselItem} from '@pb/kit-component-carousel';
import {Group, Item} from '@pb/kit-component-group';

type Props = {
    triggerAttachments: TriggerAttachment[],
    eventCodeInfo: EventDetailInfo | null,
};

const NO_ATTACHMENTS_TEXT = 'No attachments';

export const EventTriggerAttachmentView = (props: Props) => {
    const {
        triggerAttachments,
        eventCodeInfo,
    } = props;

    const [fullscreen, setFullscreen] = useState<TriggerAttachment | null>(null);

    return (
        <Group direction="v" gap="xxs" style={{height: '12rem'}}>
            <strong>Attachments:</strong>
            {triggerAttachments.length > 0 ? (
                <Carousel slidesGap={5}>
                    {triggerAttachments.map(attachment => (
                        <CarouselItem id={attachment.name} key={attachment.name}>
                            <AttachmentPreview
                                attachment={attachment}
                                eventCodeInfo={eventCodeInfo}
                                setFullscreen={setFullscreen}
                            />
                        </CarouselItem>
                    ))}
                </Carousel>
            ) : (
                <Item>{NO_ATTACHMENTS_TEXT}</Item>
            )}
            <AttachmentFullscreen attachment={fullscreen} setFullscreen={setFullscreen}/>
        </Group>
    );
};
